import { useQuery } from '@tanstack/react-query';
import { fetchAreas } from '@apis/monitor';
import type { IConfigArea } from '@d-orca/shared/trusstor';

export function useSiteAreas(siteId: string) {
  return useQuery({
    queryKey: ['areas', siteId] as const,
    queryFn: ({ signal }) => fetchAreas(siteId, signal).then((r) => r.areas as IConfigArea[]),
    enabled: !!siteId,
    staleTime: 5 * 60_000,
  });
}
